// iOS Safari resizes the visual viewport while the on-screen keyboard is open and
// sometimes fails to recompute it correctly once the keyboard closes, especially
// when combined with a DOM reflow (e.g. fields/components unmounting right after).
// Blurring the active element closes the keyboard asynchronously (~300ms animation),
// so we retry the scroll reset a few times to guarantee the viewport settles.
export function resetIOSScrollViewport() {
  const doScroll = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    // Scroll position alone doesn't fix it: Safari can keep a stale (too-wide)
    // layout viewport after the reflow, which still lets the page be dragged
    // sideways even at scrollX 0. Nudging body width forces WebKit to recompute it.
    document.body.style.width = "99.9%";
    void document.body.offsetHeight;
    document.body.style.width = "";
  };
  doScroll();
  const t1 = setTimeout(doScroll, 100);
  const t2 = setTimeout(doScroll, 350);
  return () => { clearTimeout(t1); clearTimeout(t2); };
}
